export default {
  field__account_number: '口座番号（IBAN）',
  field__document_type: '書類の種類',
  field__document_id: '書類ID',
  field__account_holder: '口座名義人',
  field__bank_name: '銀行名',
  field__bank_code: '銀行コード',
  field__bank_ifsc_code: '銀行IFSCコード(インド)',
  field__account_holder_address: '口座名義人住所',
  field__bank_address: '銀行住所',
  field__bic: 'BIC',
  field__purpose_of_payment: '支払目的',
  field__pay_id: 'PayID',
  field__card_last_four_digits: 'カード下4桁',
  field__invoice_receipt_number: '請求書受付番号',
  field__rif: 'RIF',
  field__phone: '電話番号',
  field__beneficiary: '受取人',
  field__cbu: 'CBU/CVU',
  field__alias: 'エイリアス',
};
